import { createContext } from 'react'
import socket, { fetch } from 'src/api/socket'
import { get, post } from 'src/api/fetch'

export const defaultContext = {
  socket, fetch, // socket.io
  get, post,     // REST-API
}

const ApiContext = createContext(defaultContext)

export default ApiContext